import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { CircleDollarSign } from 'lucide-react';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';

type MediaInvestmentProps = {
  aggregateLevel: AggregateLevel;
};

export const MediaInvestment: React.FC<MediaInvestmentProps> = ({
  aggregateLevel,
}) => {
  const { investments } = useMMDataContext();
  const keyMetricData: KeyMetricData = useMemo(() => {
    return {
      isLoading: investments.isLoading,
      isError: investments.isError,
      name: 'Media Investment',
      isEuro: true,
      summaryValue: investments.total,
      data: getAggregateLevelData(investments, aggregateLevel),
    };
  }, [investments, aggregateLevel]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData?.data]);

  return (
    <KeyMetricCard
      title="Media Investment"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={CircleDollarSign} boxSize={5} color="gray.500" />}
    />
  );
};
